"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getAverageBowler = (props) => {
    if (props.wickets > 0) {
        return Number((props.runs / props.wickets).toFixed(2));
    }
    return null;
};
exports.default = getAverageBowler;
//# sourceMappingURL=getAverageBowler.js.map